<template>
  <label class="intercom-toggle" :class="{ 'intercom-toggle--disabled': disabled }">
    <input
      type="checkbox"
      class="intercom-toggle__input"
      :checked="modelValue"
      :disabled="disabled"
      @change="handleChange"
    />
    <span class="intercom-toggle__slider"></span>
  </label>
</template>

<script setup>
defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const handleChange = (event) => {
  emit('update:modelValue', event.target.checked)
}
</script>

<style scoped>
.intercom-toggle {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 28px;
  flex-shrink: 0;
  cursor: pointer;
}

.intercom-toggle--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.intercom-toggle__input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.intercom-toggle__slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--color-gray-200);
  transition: var(--transition-fast) ease;
  border-radius: 28px;
}

.intercom-toggle__slider::before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: var(--color-white);
  transition: var(--transition-fast) ease;
  border-radius: 50%;
  box-shadow: var(--shadow-sm);
}

.intercom-toggle__input:checked + .intercom-toggle__slider {
  background-color: var(--color-blue);
}

.intercom-toggle__input:checked + .intercom-toggle__slider::before {
  transform: translateX(20px);
}

.intercom-toggle__input:focus-visible + .intercom-toggle__slider {
  box-shadow: var(--shadow-focus);
}

.intercom-toggle--disabled .intercom-toggle__slider {
  cursor: not-allowed;
}
</style>
